const playHeroVideo = (video) => {
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.loop = true;
  video.autoplay = true;
  const attempt = video.play();
  if (attempt && attempt.then) {
    attempt.then(() => video.classList.add('is-on')).catch(() => {});
  }
};

const setupHeroVideos = () => {
  document.querySelectorAll('.block-film video, .offer-film video').forEach((video) => {
    if (video.dataset.heroReady) {
      playHeroVideo(video);
      return;
    }
    video.dataset.heroReady = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    playHeroVideo(video);
    video.addEventListener('canplay', () => playHeroVideo(video));
    video.addEventListener('loadeddata', () => playHeroVideo(video));
    video.addEventListener('pause', () => {
      if (document.hidden || video.ended) return;
      window.setTimeout(() => playHeroVideo(video), 80);
    });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupHeroVideos);
} else {
  setupHeroVideos();
}
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) setupHeroVideos();
});

const setupSliders = () => {
  document.querySelectorAll('[data-slides]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = root.querySelector('[data-dots]');
    if (!track || !slides.length) return;
    let index = 0;
    let startX = 0;
    const existing = dots ? [...dots.querySelectorAll('button')] : [];
    if (!existing.length) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Photo ${i + 1}`);
        dots?.append(dot);
      });
    }
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots?.querySelectorAll('button').forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    };
    dots?.querySelectorAll('button').forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    root.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      if (dx > 40) go(index - 1);
      if (dx < -40) go(index + 1);
    }, { passive: true });
    go(0);
  });
};
const setupReviewSlider = () => {
  document.querySelectorAll('[data-reviews]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    const slides = [...root.querySelectorAll('[data-rev]')];
    if (!track || !slides.length) return;
    let index = 0;
    const per = () => (root.clientWidth >= 901 ? 3 : 1);
    const maxIndex = () => Math.max(0, slides.length - per());
    const go = (next) => {
      const max = maxIndex();
      index = ((next % (max + 1)) + (max + 1)) % (max + 1);
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 18;
      const step = slides[0].getBoundingClientRect().width + gap;
      track.style.transform = `translate3d(-${index * step}px,0,0)`;
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    let startX = 0;
    root.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      if (dx > 40) go(index - 1);
      if (dx < -40) go(index + 1);
    }, { passive: true });
    window.addEventListener('resize', () => go(index));
    go(0);
  });
};
const setupCustomerReviews = () => {
  const root = document.querySelector('.block-cr');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const cards = [...root.querySelectorAll('[data-cr-card]')];
  const search = root.querySelector('[data-cr-search]');
  const sort = root.querySelector('[data-cr-sort]');
  const load = root.querySelector('[data-cr-load]');
  const write = root.querySelector('[data-cr-write]');
  const form = root.querySelector('[data-cr-form]');
  const apply = () => {
    const q = (search?.value || '').trim().toLowerCase();
    const mode = sort?.value || '';
    let list = cards.slice();
    if (mode.includes('Highest')) list.sort((a, b) => Number(b.dataset.stars) - Number(a.dataset.stars));
    if (mode.includes('Lowest')) list.sort((a, b) => Number(a.dataset.stars) - Number(b.dataset.stars));
    const grid = root.querySelector('[data-cr-grid]');
    list.forEach((card) => grid.append(card));
    cards.forEach((card) => {
      const hit = !q || card.innerText.toLowerCase().includes(q);
      card.style.display = hit ? '' : 'none';
    });
  };
  search?.addEventListener('input', apply);
  sort?.addEventListener('change', apply);
  load?.addEventListener('click', () => {
    root.querySelectorAll('.cr-card.is-more').forEach((card) => {
      card.hidden = false;
      card.classList.remove('is-more');
    });
    load.remove();
  });
  write?.addEventListener('click', () => {
    if (!form) return;
    form.hidden = !form.hidden;
  });
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const ok = form.querySelector('.cr-form-ok');
    if (ok) ok.hidden = false;
    form.querySelectorAll('input, textarea, select, button[type="submit"]').forEach((el) => {
      el.disabled = true;
    });
  });
};
const setupStats = () => {
  document.querySelectorAll('[data-stats] [data-count]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const target = Number(el.getAttribute('data-count') || 0);
    const run = () => {
      let n = 0;
      const tick = () => {
        n += Math.max(1, Math.round(target / 24));
        if (n >= target) n = target;
        el.textContent = `${n}%`;
        if (n < target) requestAnimationFrame(tick);
      };
      tick();
    };
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        run();
        io.disconnect();
      }
    }, { threshold: 0.4 });
    io.observe(el);
  });
};
const setupSticky = () => {
  const sticky = document.querySelector('[data-sticky-buy]');
  if (!sticky) return;
  const onScroll = () => sticky.classList.toggle('is-on', window.scrollY > 520);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupSliders();
    setupReviewSlider();
    setupCustomerReviews();
    setupStats();
    setupSticky();
  });
} else {
  setupSliders();
  setupReviewSlider();
  setupCustomerReviews();
  setupStats();
  setupSticky();
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu]');
  if (toggle) document.querySelector('[data-nav]')?.classList.toggle('is-open');
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-localization-select]');
  if (select) select.form?.submit();

  const offer = event.target.closest('[name="puffly-offer"]');
  if (!offer) return;
  const money = offer.getAttribute('data-money') || '';
  const qty = offer.getAttribute('data-qty') || '1';
  const id = offer.getAttribute('data-id');
  const qtyInput = document.querySelector('[data-offer-qty]');
  const idInput = document.querySelector('[data-offer-id]');
  const labelSticky = `ADD TO CART — ${money}`;
  if (qtyInput) qtyInput.value = qty;
  if (idInput && id) idInput.value = id;
  document.querySelectorAll('.bp-offer').forEach((el) => {
    el.classList.toggle('is-on', el.contains(offer) && offer.checked);
  });
  document.querySelectorAll('[data-offer-btn]').forEach((el) => {
    if (el.tagName !== 'A' && el.tagName !== 'BUTTON') return;
    const base = el.getAttribute('data-label') || 'Add to cart';
    el.textContent = `${base} — ${money}`;
  });
  document.querySelectorAll('[data-sticky-cta]').forEach((el) => {
    el.textContent = labelSticky;
  });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.buy-now-form');
  if (!form || event.submitter?.closest('[data-shopify="payment-button"]')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button) {
    button.disabled = true;
    button.textContent = 'Going to checkout…';
  }
  try {
    await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    const added = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!added.ok) throw new Error('checkout');
    window.location.href = '/checkout';
  } catch (error) {
    window.location.href = '/checkout';
  }
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-thumb]');
  if (!thumb) return;
  const main = document.querySelector('[data-main-image]');
  if (main) main.src = thumb.getAttribute('data-thumb');
  document.querySelectorAll('[data-thumb]').forEach((el) => el.classList.toggle('is-active', el === thumb));
});

document.addEventListener('click', (event) => {
  const sticky = event.target.closest('[data-sticky-cta]');
  if (!sticky) return;
  const form = document.querySelector('.buy-now-form');
  if (form) form.requestSubmit();
  else document.getElementById('buy')?.scrollIntoView({ behavior: 'smooth' });
});
